import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAdmin: false,
        groupsLoaded: false,
        groups: [],
    },
    reducers: {
        setIsAdmin: (state, action) => {
            state.isAdmin = action.payload;
        },
        setGroupsLoaded: (state, action) => {
            state.groupsLoaded = action.payload;
        },
        setGroups: (state, action) => {
            state.groups = action.payload;
        },
        clearAuth: (state) => {
            state.isAdmin = false;
            state.groupsLoaded = false;
            state.groups = [];
        },
    },
});

export const { setIsAdmin, setGroupsLoaded, setGroups, clearAuth } = authSlice.actions;

export const selectIsAdmin = (state) => state.auth.isAdmin;
export const selectGroupsLoaded = (state) => state.auth.groupsLoaded;
export const selectGroups = (state) => state.auth.groups;

export default authSlice.reducer;
